import React from 'react'
import './NotFound.css'

const NotFound = () => {
  return (
    <div className='not-found'>
      <div className='notFound-img'>
        <h2>OOPS A Spilled Beer!</h2>
      </div>
    </div>
  )
}

export default NotFound